
export enum Role {
  admin = 'ADMIN',
  user = 'USER'
}
